import { useState } from "react";
import useCreate from '../useCreate';
import useDelete from '../useDelete';
import { useDisclosure } from "@mantine/hooks";

function useLevelRow(index, stepData, removeUnusedSteps) {
    // Handle input change for fields
    const {
        createMutation
    } = useCreate()

    const {
        deleteMutation
    } = useDelete()

    const [opened, { open, close }] = useDisclosure(false);

    const [step, setStep] = useState(stepData ??

    {
        id: 1,
        name: "Level 1",
        typeOfMonth: [],
        fields: [
            { label: "Monthly Income (Minimum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
            { label: "Monthly Income (Maximum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
            { label: "Live Days (optional)", value: "", currency: "Days", fixed: true, placeholder: "Enter Value" },
            { label: "Live Hours (optional)", value: "", currency: "Hours", fixed: true, placeholder: "Enter Value" },
            { label: "Bonus Managers (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
            { label: "Bonus Agents (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
            { label: "Bonus Creators (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },

        ],

    },
    );

    // Add a new step


    const handleInputChange = (stepId, fieldIndex, newValue) => {

        setStep(
            prev => (
                {
                    ...prev,
                    fields: step.fields.map((field, index) =>
                        index === fieldIndex ? { ...field, value: newValue } : field
                    ),
                }
            )
        )
    };
    // Rename a step
    const renameStep = (stepId) => {
        const newName = prompt("Enter new step name:");
        console.log("Step renamed:", step);
        if (newName) {
            setStep(
                prev => (
                    {
                        ...prev,
                        name: newName,
                    }
                )
            )
        }
        console.log("Step renamed:", step);
    };
    const handleMultiSelectChange = (stepIds) => {
        setStep(
            prev => (
                {
                    ...prev,
                    typeOfMonth: stepIds,
                }
            )
        )
    };


    const removeStep = (stepId) => {
        console.log({ stepId });
        console.log({ index });
        if (typeof stepId === "number") {
            removeUnusedSteps(index);
            close();

            return;
        }
        const formData = new FormData();
        formData.append("id", stepData?.id);
        deleteMutation.mutate(formData)
        removeUnusedSteps(index);
        // setStep(prevSteps => {
        //     const updatedSteps = [...prevSteps]; // Create a copy
        //     updatedSteps.splice(index, 1); // Remove the step at the given index
        //     return updatedSteps; // Update state
        // });
        close();
    };

    const saveStep = () => {
        // Logic to save the step
        console.log("Step saved:", step);
        const form = new FormData();
        form.append("id", step?.id);
        form.append("name", step?.name);
        step?.typeOfMonth?.map((item, index) => form.append(`bonus_type_of_months[${index}]`, item))

        form.append("minimum_monthly_income", step?.fields[0]?.value);
        form.append("bonus_manager", step?.fields[4]?.value);
        form.append("bonus_agent", step?.fields[5]?.value);
        form.append("bonus_creator", step?.fields[6]?.value);
        form.append("maximum_monthly_income", step?.fields[1]?.value);
        form.append("live_days", step?.fields[2]?.value);
        form.append("live_hours", step?.fields[3]?.value);
        createMutation.mutate(form)
    }

    return {
        handleInputChange,
        renameStep,
        saveStep,
        removeStep,
        opened,
        open,
        close,
        step,
        setStep,
        handleMultiSelectChange
    }
}

export default useLevelRow;
